require("!!/Users/jameshomer/Documents/projects/universeporn/node_modules/script-loader/addScript.js")(require("!!/Users/jameshomer/Documents/projects/universeporn/node_modules/raw-loader/index.js!/Users/jameshomer/Documents/projects/universeporn/bower_components/detectizr/dist/detectizr.js"))


//////////////////
// WEBPACK FOOTER
// ./node_modules/script-loader!./bower_components/detectizr/dist/detectizr.js
// module id = 15
// module chunks = 0